import { useEffect } from "react";

import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { getModalParams } from "domains/modal/selectors";
import type { ModalParams } from "domains/modal/types";
import { TopicFilterModal } from "domains/topicSearchFilter/components/TopicFilterModal";
import { getTopicFilters } from "domains/topicSearchFilter/selectors";
import { applyVideoSearchCriteria, clearVideoSearchCriteria } from "domains/videos/actions";
import { getVideoSearchCriteria } from "domains/videos/selectors";

export const TopicVideoFilterModal = () => {
  const dispatch = useDispatch();
  const searchCriteria = useSelector(getVideoSearchCriteria);
  const translate = useTranslate();
  const { selectedTopicId } = useSelector(getModalParams) as ModalParams<"TopicVideoFilter">;
  const filters = useSelector(getTopicFilters("videos"));

  useEffect(() => {
    dispatch(applyVideoSearchCriteria({ topicId: selectedTopicId }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <TopicFilterModal
      fields={filters}
      handleApplyFilter={(payload) => () => dispatch(applyVideoSearchCriteria(payload))}
      handleClear={() => dispatch(clearVideoSearchCriteria())}
      searchCriteria={searchCriteria}
      title={translate("app.videos.filter.title")}
    />
  );
};
